import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http'; 
import { Globals } from '../objects/Globals';
import { Observable, Subject } from 'rxjs';
import { EnvService } from '../env.service';

@Injectable({
  providedIn: 'root'
})
export class ViewService {
  private loginUrl: string;

  private refreshView = new Subject<any>();
  refreshViewChanged$ = this.refreshView.asObservable();

  setRefreshView(view: any){
    if (view){
      this.refreshView.next(view);
    }
  }
  
  createViewList(type: string):Observable<string>{
    var path = this.loginUrl +"CreateViewListCard/"+type;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  getViewList(id:string):Observable<string>{
    var path = this.loginUrl +"GetViewListCard/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getSystemViewList(id:string):Observable<string>{
    var path = this.loginUrl +"GetSystemViewListCard/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getUserViewList(id:string):Observable<string>{
    var path = this.loginUrl +"GetUserViewListCard/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getViewChildrenList(id:string, viewId:string):Observable<string>{
    var path = this.loginUrl +"GetViewChildrenList/"+id + "/" + viewId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getViewDetail(id:string, viewId:string):Observable<string>{
    var path = this.loginUrl +"GetViewDetail/"+id + "/" + viewId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  createNewView(summaryId: string, viewName: string, parentId:string){
    var path = this.loginUrl +"CreateNewView/"+summaryId + "/" + viewName + "/" + parentId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  getDocumentOutlineCard(id:string):Observable<string>{
    var path = this.loginUrl +"GetDocumentOutlineCard/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }
  
  selectOutlineItem(id:string, itemId: string):Observable<string>{
    var path = this.loginUrl +"SelectOutlineItem/"+id + "/" + itemId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getDocumentOutlineChildItems(id:string, selectedId: string):Observable<string>{
    var path = this.loginUrl +"GetDocumentOutlineChildItems/"+id + "/" + selectedId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  constructor(private http:HttpClient, private globals:Globals, private env: EnvService) { this.loginUrl = this.env.servicePath; }
}
